import HeroSection from "./components/HeroSection";
import FeaturedAnime from "./components/FeaturedAnime";
import CategorySection from "./components/CategorySection";
import LatestUpdates from "./components/LatestUpdates";
import PopularRanking from "./components/PopularRanking";
import FAQSection from "./components/FAQSection";

export default function Home() {
  return (
    <main>
      <HeroSection />
      <FeaturedAnime />
      <CategorySection />
      <PopularRanking />
      <LatestUpdates />
      <FAQSection />
    </main>
  );
}